import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import classnames from 'classnames/bind';
import styles from './errorMessage.module.scss';

const cx = classnames.bind(styles);

interface ErrorMessageProps {
  name: string;
  errors?: FieldErrors;
}

const ErrorMessage = ({ name, errors }: ErrorMessageProps) => {
  return (
    <HookFormErrorMessage
      name={name}
      render={(props: any) => <div className={cx('errorMessage')}>{props.message}</div>}
      errors={errors}
    />
  );
};

export default ErrorMessage;
